import { useQuery } from './use-query';
import { QUICK_SEARCH_LOCATION_KEY } from '../../services/quicksearch-location-service';

export const useQuickSearchTerm = () => {
  return useQuery().get(QUICK_SEARCH_LOCATION_KEY);
};
